<!-- El lienzo. `--full` lo fija a la ventana; sin él llena a su contenedor,
     que es como lo usa la espera bloqueante y como lo enseña el catálogo. -->
<div class="dxc-splash"
     [class.dxc-splash--full]="full"
     [class.dxc-splash--leaving]="leaving"
     role="status"
     aria-live="polite">
    <dxc-brand [size]="size" [intro]="true" [loading]="true" ariaLabel="dexCarga"></dxc-brand>
    @if (hint) {
        <p class="dxc-splash__hint">{{ hint }}</p>
    }
</div>
